import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { User, Milestone, UserType, Activity, Project } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection, Page } from 'elbuild-ui-lib-core';
import { Subscription, Observable, combineLatest, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { MilestoneEditComponent } from '../milestone-edit/milestone-edit.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-milestone-list',
	templateUrl: './milestone-list.component.html',
	styleUrls: ['./milestone-list.component.scss']
})
export class MilestoneListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = true;
	milestones: Milestone[] = [];

	advancedSearch: Search = new Search('milestone', 'name', 'milestone');

	@Input()
	activityid: number;
	@Input()
	projectid: number;
	project: Project;

	@Input()
	usercompanyid: number;

	loggedUser: User;
	subcription: Subscription;

	constructor(
		private milestoneService: CrudService<Milestone>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService,
		private projectService: CrudService<Project>) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('milestonedate');

	}

	ngAfterViewInit() { }

	ngOnInit() {
		this.load();

		if (this.projectid) {
			this.projectService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.milestones = [];
		this.cdr.detectChanges();

		if (this.activityid) {
			this.advancedSearch.addSimpleFilter('activityid', this.activityid);
		}
		this.advancedSearch.page = new Page(100);

		this.milestoneService.searchEntities(Milestone, 'milestone', this.advancedSearch, this.advancedSearch.page).subscribe((data: Milestone[]) => {
			this.milestones = data;
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});

	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.view(event.row.id);
			}
		}
	}


	delete(milestone: Milestone, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-milestone-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.milestoneService.deleteEntity(Milestone, 'milestone', milestone).subscribe(() => {
					this.translateService.get(['labels.milestone-deleted', 'labels.milestones']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.milestone-deleted'], messages['labels.milestones']);
						this.load();
					});
				});
			}
		});
	}


	edit(milestoneid?: number) {
		const modal = this.modalService.open(MilestoneEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.activityid = this.activityid;
		if (milestoneid) {
			modal.componentInstance.load(milestoneid);
		}
		modal.result.then((newItem: Milestone) => {
			this.load();
		}).catch(() => { });
	}

	view(milestoneid?: number) {
		if (milestoneid) {
			this.router.navigate([`/project/objective/activity/milestone/view/${milestoneid}`], { queryParamsHandling: 'merge' });
		}
	}

}
